// extracted by mini-css-extract-plugin
export default {"searchBox":"bx_gN","resultsOpen":"bx_gP"};